export default __webpack_public_path__ + "static/media/sb.9dfcf0dd.svg";